import React, { Suspense, lazy } from 'react';
import { HyperText } from '../components/HyperText';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
// Lazy load the ContactForm component
const ContactForm = lazy(() => import('../components/ContactForm'));
const ContactPage = () => {
  return <div className="w-full bg-center bg-cover bg-no-repeat bg-gray-900" data-id="element-334">
      <div className="pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-24" data-id="element-335">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal px-4" data-id="element-336">
          Contact Us
        </h1>
      </div>
      <div className="py-12 sm:py-16 md:py-24" data-id="element-337">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-338">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 mb-12 sm:mb-16" data-id="element-339">
            <div data-id="element-340">
              <h2 className="text-2xl sm:text-3xl font-light text-white mb-6 sm:mb-8 tracking-normal" data-id="element-341">
                Get In Touch
              </h2>
              <div className="mb-8" data-id="element-342">
                <div className="flex items-start gap-4 mb-4" data-id="element-343">
                  <MapPinIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#4ECDC4] flex-shrink-0 mt-1" data-id="element-344" />
                  <div data-id="element-345">
                    <h3 className="text-lg sm:text-xl font-light text-white mb-1 sm:mb-2 tracking-normal" data-id="element-346">
                      Our Location
                    </h3>
                    <p className="text-sm sm:text-base text-gray-400 font-light" data-id="element-347">
                      Orlando, FL
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-348">
                  <MailIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#4ECDC4] flex-shrink-0 mt-1" data-id="element-349" />
                  <div data-id="element-350">
                    <h3 className="text-lg sm:text-xl font-light text-white mb-1 sm:mb-2 tracking-normal" data-id="element-351">
                      Email
                    </h3>
                    <p className="text-sm sm:text-base text-gray-400 font-light" data-id="element-352">
                      info@chiroventure.com
                    </p>
                  </div>
                </div>
              </div>
              <div className="h-64 sm:h-80 w-full rounded-xl overflow-hidden border border-gray-700 shadow-sm" data-id="element-353">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224444.05358541598!2d-81.5098426751092!3d28.48114740034235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e773d8fecdbc77%3A0xac3b2063ca5bf9e!2sOrlando%2C%20FL!5e0!3m2!1sen!2sus!4v1714495651093!5m2!1sen!2sus" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Orlando, FL Map" data-id="element-354"></iframe>
              </div>
            </div>
            <div className="bg-gray-900/50 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm" data-id="element-355">
              <h2 className="text-2xl sm:text-3xl font-light text-white mb-6 sm:mb-8 tracking-normal" data-id="element-356">
                Send Us a Message
              </h2>
              <Suspense fallback={<div className="space-y-6 animate-pulse" data-id="element-358">
                    {[...Array(5)].map((_, index) => <div key={index} className="h-12 bg-gray-800/70 rounded-lg" data-id="element-359"></div>)}
                    <div className="h-32 bg-gray-800/70 rounded-lg" data-id="element-360"></div>
                    <div className="h-12 bg-gray-800/70 rounded-lg" data-id="element-361"></div>
                  </div>} data-id="element-357">
                <ContactForm data-id="element-362" />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ContactPage;